// saga.js
import { all, takeEvery, put, call } from 'redux-saga/effects';
import reportGeneratorActions from './actions';
import siteConfig from '@iso/config/site.config';
import { db } from '@iso/lib/firebase/firebase';
import { expandAggregatorIdsForApi } from '@iso/containers/ReportGenerator/config';

function applyAggregatorIdExpansion(filters) {
  if (!filters || filters.aggregator_id == null) return filters;
  return {
    ...filters,
    aggregator_id: expandAggregatorIdsForApi(filters.aggregator_id),
  };
}

export const onReportRequest = async (request) =>
  await fetch(
    `${siteConfig.apiUrl}/${
      localStorage.getItem('userRole') === 'marketplace'
        ? 'reportgeneratorMarketplace'
        : 'reportgenerator'
    }`,
    {
      crossDomain: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify(request),
    }
  )
    .then((response) => response.json())
    .then((json) => {
      return json.orders;
    });

export const onReportRequestRoma = async (request) =>
  await fetch(
    `https://orderbyte.io/api/finencial/v1/roma_orders?restaurant_id=${request.resId}`,
    {
      crossDomain: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify(request.request),
    }
  )
    .then((response) => response.json())
    .then((json) => {
      return json;
    });

export const onReportCurrentRequest = async (request) =>
  await fetch(
    `${siteConfig.apiUrl}/${
      localStorage.getItem('userRole') === 'marketplace'
        ? 'reportgeneratorMarketplace'
        : 'reportgenerator'
    }`,
    {
      crossDomain: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify(request),
    }
  )
    .then((response) => response.json())
    .then((json) => {
      return json.orders;
    });

export const onReportYesterdayRequest = async (request) =>
  await fetch(
    `${siteConfig.apiUrl}/${
      localStorage.getItem('userRole') === 'marketplace'
        ? 'reportgeneratorMarketplace'
        : 'reportgenerator'
    }`,
    {
      crossDomain: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify(request),
    }
  )
    .then((response) => response.json())
    .then((json) => {
      return json.orders;
    });

export const onFinReportRequest = async (restaurantId) =>
  await fetch(`${siteConfig.apiUrl}/generateFinancialReport/${restaurantId}`, {
    crossDomain: true,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    });

export const onFinReportFiltersRequest = async (restaurantId, filters) =>
  await fetch(`${siteConfig.apiUrl}/generateFinancialReport/${restaurantId}`, {
    crossDomain: true,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify(filters),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    });

function* fetchReportEffect({ payload }) {
  try {
    let report;
    if (payload.date_start) {
      const date_start = new Date(
        new Date(payload.date_start[0]).getTime()
      ).toISOString();
      const date_end = new Date(
        new Date(payload.date_start[1]).getTime()
      ).toISOString();

      const orderFilters = {
        ...payload,
        date_start: [date_start, date_end],
      };
      report = yield call(onReportRequest, orderFilters);
    } else {
      report = yield call(onReportRequest, payload);
    }
    yield put(reportGeneratorActions.fetchReportSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchReportFailure(error));
  }
}

function* fetchReportStartRoma({ payload }) {
  // console.log('payload---------', payload);
  try {
    let report;
    if (payload.date_start) {
      const date_start = new Date(
        new Date(payload.date_start[0]).getTime()
      ).toISOString();
      const date_end = new Date(
        new Date(payload.date_start[1]).getTime()
      ).toISOString();

      const orderFilters = {
        ...payload,
        date_start: [date_start, date_end],
      };
      report = yield call(onReportRequestRoma, orderFilters);
    } else {
      report = yield call(onReportRequestRoma, payload);
    }

    yield put(reportGeneratorActions.fetchReportStartRomaSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchReportStartRomaFailure(error));
  }
}

function* fetchReportCurrentEffect({ payload }) {
  try {
    let report;
    if (payload.date_start) {
      const date_start = new Date(
        new Date(payload.date_start[0]).getTime()
      ).toISOString();
      const date_end = new Date(
        new Date(payload.date_start[1]).getTime()
      ).toISOString();

      const orderFilters = {
        ...payload,
        date_start: [date_start, date_end],
      };
      report = yield call(onReportCurrentRequest, orderFilters);
    } else {
      report = yield call(onReportCurrentRequest, payload);
    }
    yield put(reportGeneratorActions.fetchReportCurrentSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchReportCurrentFailure(error));
  }
}

function* fetchReportYesterdayEffect({ payload }) {
  try {
    let report;
    if (payload.date_start) {
      const date_start = new Date(
        new Date(payload.date_start[0]).getTime()
      ).toISOString();
      const date_end = new Date(
        new Date(payload.date_start[1]).getTime()
      ).toISOString();

      const orderFilters = {
        ...payload,
        date_start: [date_start, date_end],
      };
      report = yield call(onReportYesterdayRequest, orderFilters);
    } else {
      report = yield call(onReportYesterdayRequest, payload);
    }
    yield put(reportGeneratorActions.fetchReportYesterdaySuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchReportYesterdayFailure(error));
  }
}

function* fetchFinReportEffect({ payload }) {
  try {
    let report = yield call(onFinReportRequest, payload);
    yield put(reportGeneratorActions.fetchFinReportSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchFinReportFailure(error));
  }
}

function* fetchFinReportFiltersEffect({ payload }) {
  try {
    let report;
    if (payload.date_start) {
      const date_start = new Date(
        new Date(payload?.date_start[0]).getTime()
      ).toISOString();
      const date_end = new Date(
        new Date(payload?.date_start[1]).getTime()
      ).toISOString();

      const orderFilters = applyAggregatorIdExpansion({
        ...payload,
        date_start: [date_start, date_end],
      });
      report = yield call(
        onFinReportFiltersRequest,
        payload.restaurant_id[0],
        orderFilters
      );
    } else {
      report = yield call(
        onFinReportFiltersRequest,
        payload.restaurant_id[0],
        applyAggregatorIdExpansion(payload)
      );
    }
    yield put(reportGeneratorActions.fetchFinReportSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchFinReportFailure(error));
  }
}

function* fetchFinReportFiltersEffectCurrent({ payload }) {
  try {
    let report;
    if (payload.date_start) {
      const date_start = new Date(
        new Date(payload?.date_start[0]).getTime()
      ).toISOString();
      const date_end = new Date(
        new Date(payload?.date_start[1]).getTime()
      ).toISOString();

      const orderFilters = applyAggregatorIdExpansion({
        ...payload,
        date_start: [date_start, date_end],
      });
      report = yield call(
        onFinReportFiltersRequest,
        payload.restaurant_id[0],
        orderFilters
      );
    } else {
      report = yield call(
        onFinReportFiltersRequest,
        payload.restaurant_id[0],
        applyAggregatorIdExpansion(payload)
      );
    }
    yield put(reportGeneratorActions.fetchFinReportSuccessCurrent(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchFinReportFailure(error));
  }
}

export const onFetchFinReportPayout = async (data) =>
  await fetch(`https://orderbyte.io/api/finencial/v1/get_stripe_data`, {
    crossDomain: true,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9',
    },
    mode: 'cors',
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    });

function* fetchFinReportPayout({ payload }) {
  console.log('payout patload-----------', payload);
  let data = {
    brand_id: Number(payload.brandId),
    restaurant_id: Number(payload.restaurant_id),
  };

  // let data = {
  //   brand_id: 18705,
  //   restaurant_id: 17343
  // };

  try {
    let report = yield call(onFetchFinReportPayout, data);

    yield put(reportGeneratorActions.fetchFinReportPayoutSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchFinReportPayoutFailure(error));
  }
}

export const onFetchFinReportPayoutDetail = async (data) =>
  await fetch(`https://orderbyte.io/api/finencial/v1/get_charges_for_payout`, {
    crossDomain: true,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9',
    },
    mode: 'cors',
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    });

function* fetchFinReportPayoutDetail({ payload }) {
  // console.log("payout patload-----------", payload);
  let data = {
    account_id: payload.account_id,
    payout_id: payload.payout_id,
  };

  // let data = {
  //   account_id: "acct_1P8rDMPM7LfLgjoQ",
  //   payout_id: "po_1Q7SSzPM7LfLgjoQHubDy9g8"
  // }

  try {
    let report = yield call(onFetchFinReportPayoutDetail, data);
    // console.log("report payout detailed", report);

    yield put(reportGeneratorActions.fetchFinReportPayoutDetailSuccess(report));
  } catch (error) {
    yield put(reportGeneratorActions.fetchFinReportPayoutDetailFailure(error));
  }
}

export default function* reportGeneratorSaga() {
  yield all([
    takeEvery(reportGeneratorActions.FETCH_REPORT_START, fetchReportEffect),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_REPORT_START_ROMA,
      fetchReportStartRoma
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_REPORT_CURRENT_START,
      fetchReportCurrentEffect
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_REPORT_YESTERDAY_START,
      fetchReportYesterdayEffect
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_FIN_REPORT_START,
      fetchFinReportEffect
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_FIN_REPORT_FILTERS_START,
      fetchFinReportFiltersEffect
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_FIN_REPORT_FILTERS_START_CURRENT,
      fetchFinReportFiltersEffectCurrent
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_FIN_REPORT_PAYOUT,
      fetchFinReportPayout
    ),
  ]);
  yield all([
    takeEvery(
      reportGeneratorActions.FETCH_FIN_REPORT_PAYOUT_DETAIL,
      fetchFinReportPayoutDetail
    ),
  ]);
}
